import { baseApi } from '../../../core/baseApi';
import type { Schema } from '@voley/shared-types';

/** Request body for push subscription — uses Schema<'PushSubscribeBody'> */
export type PushSubscriptionData = Schema<'PushSubscribeBody'>;

/** Subscribe response data */
export type PushSubscriptionResponse = Schema<'SubscribeResponse'>;

/** VAPID public key response data */
export type VapidPublicKeyResponse = Schema<'VapidKeyResponse'>;

/** Push subscription list item */
export type PushSubscriptionsListResponse = Schema<'PushSubscriptionResponse'>;

export const pushApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVapidPublicKey: builder.query<VapidPublicKeyResponse, void>({
      query: () => '/notifications/push/vapid-key',
      transformResponse: (response: Schema<'NotificationVapidKeyResponse'>) => response.data,
    }),

    subscribeToPush: builder.mutation<PushSubscriptionResponse, PushSubscriptionData>({
      query: (payload) => ({
        url: '/notifications/push/subscribe',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['PushSubscriptions'],
      transformResponse: (response: Schema<'NotificationPushSubscribeResponse'>) => response.data,
    }),

    unsubscribeFromPush: builder.mutation<void, { endpoint: string }>({
      query: (payload) => ({
        url: '/notifications/push/unsubscribe',
        method: 'DELETE',
        body: payload,
      }),
      invalidatesTags: ['PushSubscriptions'],
    }),

    getPushSubscriptions: builder.query<PushSubscriptionsListResponse[], void>({
      query: () => '/notifications/push/subscriptions',
      providesTags: ['PushSubscriptions'],
      transformResponse: (response: Schema<'NotificationPushSubscriptionsListResponse'>) => response.data,
    }),

    testPushNotification: builder.mutation<void, void>({
      query: () => ({
        url: '/notifications/push/test',
        method: 'POST',
      }),
    }),
  })
});

export const {
  useGetVapidPublicKeyQuery,
  useSubscribeToPushMutation,
  useUnsubscribeFromPushMutation,
  useGetPushSubscriptionsQuery,
  useTestPushNotificationMutation,
} = pushApi;
